const echartsRefDictionary: any = {}

export const setEChartsRef = (key: number, ref: any) => {
    echartsRefDictionary[key] = ref
}
export const getEChartsRef = (key: number) =>
    echartsRefDictionary[key]
